// extracted by mini-css-extract-plugin
export default {"container":"Damages_container__m1mOX","page":"Damages_page__D-2H1","section":"Damages_section__xfrfg"};